import { BaseBonusModel } from "../../bonusModels/baseBonusModel";

export class ClaimBonusPostRequestModel extends BaseBonusModel {
    /** Адрес, на который будут зачислены бонусы */
    AddressTo: string;
    /** Количество бонуса */
    Amount: number;
}